import React from 'react'

const CMSContext = React.createContext({})

export default CMSContext
